__turbopack_context__.v({
  "body": "index-module__bog-DG__body",
  "closeButton": "index-module__bog-DG__closeButton",
  "icon": "index-module__bog-DG__icon",
  "message": "index-module__bog-DG__message",
  "root": "index-module__bog-DG__root",
});
